// src/plugins/vuetify.ts
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { aliases, mdi } from "vuetify/iconsets/mdi";
import { md2 } from "vuetify/blueprints";
import "vuetify/styles"; // Vuetify 3 のスタイルを読み込む

const v2LikeColors = {
  primary: '#1976D2',
  'primary-darken-1': '#1565C0',
  secondary: '#424242',
  'secondary-darken-1': '#1B1B1B',
  accent: '#82B1FF',
  error: '#FF5252',
  info: '#2196F3',
  success: '#4CAF50',
  warning: '#FFC107',
  background: '#FFFFFF',
  'surface-light': '#FFFFFF',
  'on-background': '#212121',
  'on-surface': '#212121',
  'on-primary': '#FFFFFF',
  return: '#F5F5F5',
  'on-return': '#000000',
}

const vuetify = createVuetify({
  components,
  directives,
  blueprint: md2,
  icons: {
    defaultSet: "mdi",
    aliases,
    sets: {
      mdi,
    },
  },
  theme: {
    defaultTheme: "v2like",
    themes: {
      v2like: {
        dark: false,
        colors: v2LikeColors,
        variables: {
          'border-color': '#E0E0E0',
          'border-opacity': 0.4,
          rounded: '4px',
          'hover-opacity': 0.04,
          'theme-overlay-multiplier': 1,
        },
      },
    }
  },
});

export default vuetify;
